import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function CountUp({
  end,
  label,
  prefix = '',
  suffix = ''
}: {
  end: number;
  label: string;
  prefix?: string;
  suffix?: string;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (isInView) {
      let start = 0;
      const duration = 2000; // 2 seconds
      const increment = end / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isInView, end]);
  return <div ref={ref} className="text-center" data-id="element-218">
      <div className="text-5xl md:text-7xl font-serif text-clay mb-3" data-id="element-219">
        {prefix}
        {count.toLocaleString()}
        {suffix}
      </div>
      <div className="text-sm md:text-base text-charcoal uppercase tracking-widest font-medium" data-id="element-220">
        {label}
      </div>
    </div>;
}
export function ImpactNumbers() {
  return <section className="py-24 md:py-32 px-4 md:px-8" data-id="element-221">
      <div className="max-w-[1200px] mx-auto" data-id="element-222">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-8" data-id="element-223">
          <CountUp end={10} label="OTL modelados" data-id="element-224" />
          <CountUp end={14} label="Municipios TEFOS" data-id="element-225" />
          <CountUp end={500} prefix="+" label="Personas formadas" data-id="element-226" />
          <CountUp end={195} label="Acuerdos de conservación" data-id="element-227" />
        </div>
      </div>
    </section>;
}